import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
import { LensStates } from './lens-states';
export var ImpersonatedUser = t.type({
  uuid: t.string,
  name: t.string,
  'profile-image': nullable(t.string)
});
export var ImpersonatorUser = t.type({
  'is-super-admin': t["boolean"]
});
export var ClearedLens = t.type({
  state: t.literal(LensStates.Cleared)
});
export var LoadingLens = t.type({
  state: t.literal(LensStates.Loading),
  'impersonator-uuid': t.string,
  'clone-uuid': t["null"],
  'loaded-at': t["null"],
  'impersonated-user': ImpersonatedUser,
  'impersonator-user': ImpersonatorUser,
  'group-name': nullable(t.string),
  'loaded-at-with-timezone': t["null"]
});
export var LoadedLens = t.type({
  state: t.literal(LensStates.Loaded),
  'impersonator-uuid': t.string,
  'clone-uuid': nullable(t.string),
  'loaded-at': nullable(t.string),
  'impersonated-user': ImpersonatedUser,
  'impersonator-user': ImpersonatorUser,
  'group-name': nullable(t.string),
  'loaded-at-with-timezone': nullable(t.string)
});
export var ActiveLens = t.type({
  state: t.literal(LensStates.Active),
  'impersonator-uuid': t.string,
  'clone-uuid': t.string,
  'loaded-at': t.string,
  'impersonated-user': ImpersonatedUser,
  'impersonator-user': ImpersonatorUser,
  'group-name': nullable(t.string),
  'loaded-at-with-timezone': t.string
});
export var CreateErrorLens = t.type({
  state: t.literal(LensStates.CreateError),
  'impersonator-uuid': t.string,
  'clone-uuid': t["null"],
  'loaded-at': t["null"],
  'impersonated-user': ImpersonatedUser,
  'impersonator-user': ImpersonatorUser,
  'group-name': nullable(t.string),
  'loaded-at-with-timezone': t["null"]
});
export var CancelErrorLens = t.type({
  state: t.literal(LensStates.CancelError),
  'impersonator-uuid': t.string,
  'clone-uuid': t["null"],
  'loaded-at': t["null"],
  'impersonated-user': ImpersonatedUser,
  'impersonator-user': ImpersonatorUser,
  'group-name': nullable(t.string),
  'loaded-at-with-timezone': t["null"]
});
export var ActiveErrorLens = t.type({
  state: t.literal(LensStates.ActiveError),
  'impersonator-uuid': t.string,
  'clone-uuid': nullable(t.string),
  'loaded-at': nullable(t.string),
  'impersonated-user': ImpersonatedUser,
  'impersonator-user': ImpersonatorUser,
  'group-name': nullable(t.string),
  'loaded-at-with-timezone': nullable(t.string)
});
export var ClearErrorLens = t.type({
  state: t.literal(LensStates.ClearError),
  'impersonator-uuid': t.string,
  'clone-uuid': nullable(t.string),
  'loaded-at': nullable(t.string),
  'impersonated-user': ImpersonatedUser,
  'impersonator-user': ImpersonatorUser,
  'group-name': nullable(t.string),
  'loaded-at-with-timezone': nullable(t.string)
});
export var RefreshErrorLens = t.type({
  state: t.literal(LensStates.RefreshError),
  'impersonator-uuid': t.string,
  'clone-uuid': nullable(t.string),
  'loaded-at': nullable(t.string),
  'impersonated-user': nullable(ImpersonatedUser),
  'impersonator-user': ImpersonatorUser,
  'group-name': nullable(t.string),
  'loaded-at-with-timezone': nullable(t.string)
});
export var ErrorStateLens = t.union([CreateErrorLens, ClearErrorLens, CancelErrorLens, ActiveErrorLens, RefreshErrorLens], 'ErrorStateLens');
export var SuccessStateLens = t.union([ClearedLens, LoadingLens, LoadedLens, ActiveLens], 'SuccessStateLens');
export var Lens = t.union([SuccessStateLens, ErrorStateLens]);
export var HubApiLensResponse = t.type({
  data: nullable(t.type({
    type: t.literal('lens'),
    id: t.string,
    attributes: SuccessStateLens
  }))
});